export default __webpack_public_path__ + "static/media/fresh.713ec695.jpg";